import React from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useRouteMatch
} from "react-router-dom";
import BoardDetail from "./boarddetail";
import BoardList from "./BoardList";
import BoardWrite from "./BoardWrite";


const Board = ({ componentName, data }) => {
  // API 통신 (ROLE = componentData) 필요 (method = get)
  const match = useRouteMatch();
  return (
    <>
      <Router>
        <Switch>
          <Route
            exact
            path={match.path}
            component={() => <BoardList BoardType={componentName} BoardData={data} />}
          />
          <Route path={`${match.path}/detail/:no`} component={BoardDetail} />
          <Route path={`${match.path}/write`} component={BoardWrite} />
        </Switch>
      </Router>
    </>
  );
};

export default Board;
